import { createTopic } from '../lib';
import { z } from 'zod';

const teamRolesOnboardedEventSchema = z.object({
  subject: z.string(),
  entityUrn: z.string(),
  isManuallyOnboarded: z.boolean(),
});

export type TeamRolesOnboardedEvent = z.infer<
  typeof teamRolesOnboardedEventSchema
>;

export const teamRolesOnboardedTopic = createTopic<TeamRolesOnboardedEvent>(
  {
    namespace: 'control-plane',
    name: 'team-roles-onboarded',
    description: 'User onboarded an existing project to team roles management',
  },
  teamRolesOnboardedEventSchema,
);
